import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { useAnimationConfig } from '../../../context/occ/hooks/use-animation-config';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Icon } from '../../../subcomponents/icon/icon';
import { getFormattedSiteAddress } from '../../../utils/get-formatted-site-address';
const b = bemClassBuilder('v-site-picker-unselected-site');
export const SitePickerUnselectedSite = observer(props => {
    const i18n = useI18n();
    const { enableAnimations } = useAnimationConfig();
    const { site, disabled, onClick } = props;
    const address = getFormattedSiteAddress(site.contactDetails.address);
    const handleClick = () => onClick(site.id);
    const animationProps = enableAnimations
        ? {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            transition: { stiffness: 500, damping: 50 },
            layout: true
        }
        : {};
    return (_jsx(motion.li, Object.assign({ className: b.block({ disabled: disabled }) }, animationProps, { children: _jsx("button", { className: b.element('button'), onClick: handleClick, disabled: disabled, children: _jsxs("div", { className: b.element('button-wrapper'), children: [_jsx(Icon, { className: b.element('add-icon'), name: "plus-square" }), _jsxs("div", { className: b.element('details'), children: [_jsx("span", { className: b.element('name'), children: i18n.translatable(site.name) }), address && _jsx("span", { className: b.element('address'), children: address })] })] }) }) })));
});
SitePickerUnselectedSite.displayName = 'SitePickerUnselectedSite';
//# sourceMappingURL=unselected-site.js.map